import React, { useState } from 'react'
import './styles.scss'

interface Props {
    options : string[]
    selectedOption : string
    inputValue : string
    onOptionChangeSelectBox : any
    onValueChangeInput :any
}


const SelectBoxSearch = ({options,selectedOption,onOptionChangeSelectBox,onValueChangeInput, inputValue}:Props) => {

    return (
        <div className='background_component'>
            <div className='select-box'>
                <select id="selectBox" value={selectedOption} onChange={onOptionChangeSelectBox}>
                    <option value="" disabled>Select an option</option>
                    {options.map((option,index) => (
                        <option key={index} value={option}>{option}</option>
                    ))}
                </select>
            </div>
            <div className='search_input'>
                <input className='input-no-border' type="text" placeholder="Búsqueda" onChange={onValueChangeInput} value={inputValue}/>
                <img src="/assets/icons/lookFor.svg" alt='logo' height={30} width={30}/>
            </div>

        </div>
    )
}

export default SelectBoxSearch